import {
  NEW_CHATVISOR,
  NEW_MESSAGE_CHAT_VISOR,
  REMOVE_CONVERSATION,
  SET_VIEW_LIST_SUPERVISORS,
  SET_SUPERVISOR_CONNECTED_ON_CHAT,
  RESET_CHATVISOR,
} from '@/store/mutation-types';
import {
  sendMessageChatVisor,
  logoff,
  supervisorsLogged,
  startNewChatVisor,
  endChatVisor,
} from '@/services/chat-visor-service';

import NewChatvisorEvent from '@/weon/events/NewChatvisorEvent';

const actions = {
  notificationNewChatVisor({ dispatch, state }, supervisorId) {
    const { chats } = state;
    const chatVisorSupervisor = chats.find(
      (chat) => chat.supervisorId == supervisorId,
    );

    const isFirstMessage = chatVisorSupervisor.messages.length == 0;

    if (isFirstMessage) {
      const notification = {
        type: 'chatVisor',
        text: 'chatVisor.newMessageChatVisor',
        browserNotify: true,
      };

      dispatch('showSnackbar', notification, { root: true });
    }
  },

  newChatvisor({ commit }, newChatVisor) {
    newChatVisor.supervisorConnectedOnChat = true;
    commit(NEW_CHATVISOR, newChatVisor);
  },

  setSupervisorConnectedOnChat({ commit }, { connected, chatVisorUser }) {
    commit(SET_SUPERVISOR_CONNECTED_ON_CHAT, { connected, chatVisorUser });
  },

  newMessageChatvisor({ commit, dispatch }, { message, supervisorId }) {
    dispatch('notificationNewChatVisor', supervisorId);
    commit(NEW_MESSAGE_CHAT_VISOR, { message, supervisorId });
  },

  async startNewChatVisor({ dispatch }, param) {
    try {
      const newChatVisor = await startNewChatVisor(param);
      new NewChatvisorEvent(newChatVisor);
    } catch (err) {
      console.error(err);
      const alert = {
        text: 'chatVisor.errConnect',
        type: 'err',
      };
      dispatch('showSnackbar', alert, { root: true });
    }
  },

  async reconnectWithSupervisor({}, param) {
    await startNewChatVisor(param);
  },

  async sendMessageConversation({ commit }, { message, supervisorId }) {
    try {
      commit(NEW_MESSAGE_CHAT_VISOR, { message, supervisorId });
      await sendMessageChatVisor(message);
    } catch (err) {
      console.error(err);
    }
  },

  closeConversation({ commit }, { agentId, supervisorId, chatvisorUser }) {
    const params = {
      agent: agentId,
      supervisor: supervisorId,
      from: agentId,
    };

    endChatVisor(params);

    commit(REMOVE_CONVERSATION, chatvisorUser);
  },

  endChatVisorEvent({ commit }, chatvisorUser) {
    commit(REMOVE_CONVERSATION, chatvisorUser);
  },

  getSupervisorsLogged({ commit }, agentId) {
    return supervisorsLogged(agentId);
  },

  async logoff({ commit }, agentId) {
    const reponse = await logoff({ agentId });
  },

  setViewLoggedSupervisors({ commit }, show) {
    commit(SET_VIEW_LIST_SUPERVISORS, show);
  },

  reset({ commit }) {
    commit(RESET_CHATVISOR);
  },
};

export default actions;
